import {
  SET_CAPTURE_SELECTION, SET_CAPTURE_SELECTIONS, SET_PRINT_CAPTURES, SET_CAPTURES_RENDERED,
  SET_SELECTED_VIOLATION_KEY_NUMBER,
  SET_CAPTURE_MODAL_STATUS, SET_SETTINGS_MODAL_STATUS, SET_FILTER_MODAL_STATUS, SET_PRINTER_MODAL_STATUS, SET_EXPORT_MODAL_STATUS,
  SET_SHARE_MODAL_STATUS, SET_SEARCH_MODAL_STATUS,
  SET_SELECTED_VIOLATION_ID, SET_PAGE_CAPTURE_LIMIT, SET_SCROLL_STATUS,
  SET_FILTER, SET_VIEW, SET_PAGE, SET_PAGE_CHANGED, SET_ALL_CHECKED,
  SET_MY_SCHOOLS_STATUS, SET_SELECTED_CAPTURES, SET_PAGE_VIEW,
  SET_REPORTS_MODAL_STATUS,
  SET_GROUP_INDEX, SET_FLAGGED_ONLY,
  SET_DEFAULT_REPORT_SET,
  LOGOUT,
  SET_FROM_VIEW,
  SET_STATUS_SNACK,
  SET_TRIGGER_FILTER,
  SET_AWAIT_TRIGGER,
  SET_FROM_LINK,
  SET_REPORT,
  SET_PAGE_TYPE,
  SET_CAPTURES_EXHAUSTED,
  SET_END_OF_LINK,
  SET_NEED_FILTER
} from '../types'

import { getToken } from './auth'

import { cloneDeep } from 'lodash'

import { defaultFilter } from '../../utils'

import { trackPromise } from 'react-promise-tracker'
import log from 'loglevel'

const api = (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'http:' ? 'http://' + window.location.hostname + ':3080' : (process.env.REACT_APP_ON_PREM === true || process.env.REACT_APP_ON_PREM === 'true') && window.location.protocol === 'https:' ? 'https://' + window.location.hostname + ':8443' : process.env.REACT_APP_API_URL

export function setCaptureSelection (capture) {
  return async function (dispatch) {
    dispatch({
      type: SET_CAPTURE_SELECTION,
      payload: capture
    })
  }
}

export function setCaptureSelections (captures) {
  return async function (dispatch) {
    dispatch({
      type: SET_CAPTURE_SELECTIONS,
      payload: captures
    })
  }
}

export function setCapturesRendered (capturesRendered) {
  return async function (dispatch) {
    dispatch({
      type: SET_CAPTURES_RENDERED,
      payload: capturesRendered
    })
  }
}

export function setPrintCaptures (captures) {
  return async function (dispatch) {
    dispatch({
      type: SET_PRINT_CAPTURES,
      payload: captures
    })
  }
}

export function setSelectedViolationId (id) {
  return async function (dispatch) {
    dispatch({
      type: SET_SELECTED_VIOLATION_ID,
      payload: id
    })
  }
}

export function setSelectedViolationKeyNumber (keyNumber) {
  return async function (dispatch) {
    dispatch({
      type: SET_SELECTED_VIOLATION_KEY_NUMBER,
      payload: keyNumber
    })
  }
}

export function setScrollStatus (val) {
  return async function (dispatch) {
    dispatch({
      type: SET_SCROLL_STATUS,
      payload: val
    })
  }
}

export function setCaptureModal (show) {
  return async function (dispatch) {
    dispatch({
      type: SET_CAPTURE_MODAL_STATUS,
      payload: show
    })
  }
}

export function setSettingsModal (show) {
  return async function (dispatch) {
    dispatch({
      type: SET_SETTINGS_MODAL_STATUS,
      payload: show
    })
  }
}

export function setFilterModal (show) {
  return async function (dispatch) {
    dispatch({
      type: SET_FILTER_MODAL_STATUS,
      payload: show
    })
  }
}

export function setReportsModal (show) {
  return async function (dispatch) {
    dispatch({
      type: SET_REPORTS_MODAL_STATUS,
      payload: show
    })
  }
}

export function setPrinterModal (show) {
  return async function (dispatch) {
    dispatch({
      type: SET_PRINTER_MODAL_STATUS,
      payload: show
    })
  }
}

export function setExportModal (show) {
  return async function (dispatch) {
    dispatch({
      type: SET_EXPORT_MODAL_STATUS,
      payload: show
    })
  }
}

export function setShareModal (show) {
  return async function (dispatch) {
    dispatch({
      type: SET_SHARE_MODAL_STATUS,
      payload: show
    })
  }
}

export function setSearchModal (show) {
  return async function (dispatch) {
    dispatch({
      type: SET_SEARCH_MODAL_STATUS,
      payload: show
    })
  }
}

export function setMySchoolsModal (show) {
  return async function (dispatch) {
    dispatch({
      type: SET_MY_SCHOOLS_STATUS,
      payload: show
    })
  }
}

export function setFilter (filter) {
  return async function (dispatch) {
    dispatch({
      type: SET_FILTER,
      payload: filter
    })
  }
}

export function setPage (pageNumber) {
  return async function (dispatch) {
    dispatch({
      type: SET_PAGE,
      payload: pageNumber
    })
  }
}

export function setPageChanged (status) {
  return async function (dispatch) {
    dispatch({
      type: SET_PAGE_CHANGED,
      payload: status
    })
  }
}

export function setAllChecked (status) {
  return async function (dispatch) {
    dispatch({
      type: SET_ALL_CHECKED,
      payload: status
    })
  }
}

export function setPageCaptureLimit (limit) {
  return async function (dispatch) {
    dispatch({
      type: SET_PAGE_CAPTURE_LIMIT,
      payload: limit
    })
  }
}

export function setView (view) {
  return async function (dispatch) {
    dispatch({
      type: SET_VIEW,
      payload: view
    })
  }
}

export function setPageView (view) {
  return async function (dispatch) {
    dispatch({
      type: SET_PAGE_VIEW,
      payload: view
    })
  }
}

export function setSelectedCaptures (captures) {
  return async function (dispatch) {
    dispatch({
      type: SET_SELECTED_CAPTURES,
      payload: captures
    })
  }
}

export function setSelectedReport (report) {
  return async function (dispatch) {
    dispatch({
      type: SET_REPORT,
      payload: report
    })
  }
}

export function setGroupIndex (index) {
  return async function (dispatch) {
    dispatch({
      type: SET_GROUP_INDEX,
      payload: index
    })
  }
}
export function setStatusSnack (status) {
  return async function (dispatch) {
    dispatch({
      type: SET_STATUS_SNACK,
      payload: status
    })
  }
}
export function setAwaitTrigger (status) {
  return async function (dispatch) {
    dispatch({
      type: SET_AWAIT_TRIGGER,
      payload: status
    })
  }
}

export function setTriggerFilter (status) {
  return async function (dispatch) {
    dispatch({
      type: SET_TRIGGER_FILTER,
      payload: status
    })
  }
}

export function setFlaggedOnly (flagged) {
  return async function (dispatch) {
    dispatch({
      type: SET_FLAGGED_ONLY,
      payload: flagged
    })
  }
}

export function setDefaultReportSet (index) {
  return async function (dispatch) {
    dispatch({
      type: SET_DEFAULT_REPORT_SET,
      payload: index
    })
  }
}

export const setFromView = (view) => {
  return async function (dispatch) {
    dispatch({
      type: SET_FROM_VIEW,
      payload: view
    })
  }
}

export const setFromLink = (status) => {
  return async function (dispatch) {
    dispatch({
      type: SET_FROM_LINK,
      payload: status
    })
  }
}

export const setPageType = (type) => {
  return async function (dispatch) {
    dispatch({
      type: SET_PAGE_TYPE,
      payload: type
    })
  }
}

export const setCapturesExhausted = (status) => {
  return async function (dispatch) {
    dispatch({
      type: SET_CAPTURES_EXHAUSTED,
      payload: status
    })
  }
}

export const setEndOfLink = (status) => {
  return async function (dispatch) {
    dispatch({
      type: SET_END_OF_LINK,
      payload: status
    })
  }
}

export const setNeedFilter = (status) => {
  return async function (dispatch) {
    dispatch({
      type: SET_NEED_FILTER,
      payload: status
    })
  }
}

export const getFromUrl = () => {
  return function (dispatch, getState) {
    const fromUrl = getState().selection.fromUrl
    return fromUrl
  }
}

/**
 * Returns a filtered list of violations from ElasticSearch
 * @async
 * @method filterViolations
 * @param {Object} filter Filter params to be used in ES call
 * @returns Array of violations
 */
export const getViolationsFromLink = (link) => {
  return async function (dispatch, getState) {
    const { token, tokenExp, accountId, supervisorID } = getState().auth
    const authToken = await getToken({ token, tokenExp, accountId, supervisorID }, dispatch)

    const options = {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${authToken}`
      }
    }
    const response = await trackPromise(window.fetch(`${api}/accounts/${accountId}/violation/link/${link}`, options))
    if (response.status === 401 || response.status === 403) {
      dispatch({
        type: LOGOUT,
        payload: {
          message: 'Session expired. Please log in again.',
          error: true
        }
      })
      return false
    }
    log.info('got data without error')
    const data = await response.json()
    if (!data || !data.violationIDs || !data.violationIDs.length) { return false }
    log.debug(data)
    const ids = data.violationIDs.map((object) => object.violationID)
    const filter = cloneDeep(defaultFilter)
    filter.violationIDs = ids
    dispatch({
      type: SET_FROM_LINK,
      payload: true
    })
    dispatch({
      type: SET_FILTER,
      payload: filter
    })
  }
}
